import React from "react";
import {DoneRounded} from "@mui/icons-material";
import {LoadingButton as MuiLoadingButton} from "@mui/lab";

export const LoadingButton = React.forwardRef(function (props, ref) {

    const {success, sx, ...restProps} = props;
    const loadingBtnStyles = {
        ...(success && {
            background: theme => theme.palette.success.main + "!important",
            color: "#fff!important",
        }),
    }

    return (
        <MuiLoadingButton
            variant="contained" disabled={success}
            sx={{...loadingBtnStyles, ...sx}}
            {...restProps}
            ref={ref}
            startIcon={!success && props.startIcon && props.startIcon}
            endIcon={!success && props.endIcon && props.endIcon}>
            {success ? <DoneRounded/> : props.children}
        </MuiLoadingButton>
    )
})